/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { action } from '@ember/object';
const hash = str => {
  return Array.from(str).reduce((hash, char) => (hash << 5) - hash + char.charCodeAt(0) | 0, 0);
};

// Adapted from https://github.com/gka/chroma.js/blob/main/src/io/hsl/hsl2rgb.js
const hsl2rgb = (h, s, l) => {
  let r, g, b;
  if (s === 0) {
    r = g = b = l * 255;
  } else {
    const t3 = [0, 0, 0];
    const c = [0, 0, 0];
    const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const t1 = 2 * l - t2;
    const h_ = h / 360;
    t3[0] = h_ + 1 / 3;
    t3[1] = h_;
    t3[2] = h_ - 1 / 3;
    for (let i = 0; i < 3; i++) {
      // @ts-expect-error
      if ((t3[i] ?? 0) < 0) t3[i] += 1;
      // @ts-expect-error
      if ((t3[i] ?? 0) > 1) t3[i] -= 1;
      if (6 * (t3[i] ?? 0) < 1) c[i] = t1 + (t2 - t1) * 6 * (t3[i] ?? 0);else if (2 * (t3[i] ?? 0) < 1) c[i] = t2;else if (3 * (t3[i] ?? 0) < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - (t3[i] ?? 0)) * 6;else c[i] = t1;
    }
    [r, g, b] = [Math.round(c[0] * 255), Math.round(c[1] * 255), Math.round(c[2] * 255)];
  }
  return [r, g, b];
};
let MockAvatar = (_class = class MockAvatar extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "size", 500);
  }
  // Turn a string into a numeric seed
  get seed() {
    return hash(this.args.str ?? '');
  }

  // Turn a numeric seed into a 5x5 bool grid with vertical symmetry based on
  get grid() {
    const seed = this.seed;
    const rows = [];
    for (let y = 0; y < 5; y++) {
      const row = [];
      for (let x = 0; x < 3; x++) {
        const b = !!(seed & 1 << y * 3 + x);
        row[x] = b;
        if (x !== 2) row[4 - x] = b;
      }
      rows.push(row);
    }
    return rows;
  }

  // Turn a numeric seed into an hsl color
  get color() {
    const seed = this.seed;
    return hsl2rgb(seed % 360, (seed % 13 + 45) / 100, (seed % 17 + 73) / 100);
  }
  get colorStr() {
    const [r, g, b] = this.color;
    return `rgb(${r}, ${g}, ${b})`;
  }
  draw(canvas) {
    const margin = 30;
    const size = (this.size - margin * 2) / 5;
    const grid = this.grid;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.fillStyle = '#F2F2F2';
    ctx.fillRect(0, 0, this.size, this.size);
    ctx.fillStyle = this.colorStr;
    for (let y = 0; y < grid.length; y++) {
      const row = grid[y];
      if (!row) continue;
      for (let x = 0; x < row.length; x++) {
        if (row[x]) ctx.fillRect(x * size + margin, y * size + margin, size, size);
      }
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "seed", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "seed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "grid", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "grid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "draw", [action], Object.getOwnPropertyDescriptor(_class.prototype, "draw"), _class.prototype), _class);
export { MockAvatar as default };